import * as React from 'react';
import CheckboxCheckedOutlined from './checkbox-checked-outlined';
import CheckboxCheckedFilled from './checkbox-checked-filled';
import type { IconCombinedProps } from './types';
const CheckboxCheckedCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <CheckboxCheckedFilled ref={ref} {...rest} />;
  }
  return <CheckboxCheckedOutlined ref={ref} {...rest} />;
});
export default CheckboxCheckedCombined;